import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Typography } from '@knockrentals/knock-shared-web-v2';
import { Card, CardContent } from '@material-ui/core';
import { makeCss } from '../../../../knock-design-system';

const useCss = makeCss((theme) => ({
  errorCard: {
    backgroundColor: 'rgba(255, 220, 230, 0.9)',
    borderColor: theme.palette.error.main,
    boxSizing: 'border-box',
    height: '200px',
    position: 'relative',
    width: '200px',
  },
  errorCardContent: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '16px',
    height: '100%',
  },
  errorMessage: {
    marginTop: '8px',
  },
  removeButtonWrapper: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

const ImageValidationErrorCard = ({
  clearErrorMessage,
  errorMessage,
  fileName,
}) => {
  const css = useCss();

  return (
    <Card
      aria-label="file validation error"
      css={css.errorCard}
      variant="outlined"
    >
      <CardContent css={css.errorCardContent}>
        <div css={css.removeButtonWrapper}>
          <IconButton
            aria-label="remove"
            color="destructive"
            iconName="close-circle"
            onClick={clearErrorMessage}
            tooltipText="remove"
          />
        </div>

        <Typography
          align="center"
          className={css.errorMessage}
          color="error.600"
          variant="body2"
        >
          {errorMessage}
        </Typography>

        <Typography align="center" color="error.600" variant="subtitle2">
          {fileName}
        </Typography>
      </CardContent>
    </Card>
  );
};

ImageValidationErrorCard.propTypes = {
  clearErrorMessage: PropTypes.func,
  errorMessage: PropTypes.string,
  fileName: PropTypes.string,
};

export default ImageValidationErrorCard;
